export const lightProfileToValueMap = {
	BiologicalWhite: 'BiologicalWhite',
	BiologicalRed: 'BiologicalRed',
	AdjustingWhite: 'AdjustingWhite',
	DynamicAmbience: 'DynamicAmbience',
	DynamicPath: 'DynamicPath',
	Test: 'None'
};
